app.loader = {};
(function(loader){
	// {fn} load images
	loader.images = function($block, callback, complete) {
		var loaded = 0;
		// check callbacks
		complete = complete || $.noop;
		callback = callback || $.noop;
		// init plugin
		$block.imagesLoaded().progress(function(instance){
			loaded++;
			callback(loaded, instance.images.length);
		}).always(complete);
	};
})(app.loader);